import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { HeaderLogoImageComponent } from '../../header-logo/header-logo-image.component';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'mwe-custom-popup',
  templateUrl: './custom-popup.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderLogoImageComponent, TranslateDirective],
})
export class CustomPopupComponent {
  dismissClicked = output();
  popupTitle = input('global.title');
  isDismissible = input(true);
}
